// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"71b852f5e0f59693","3072":"8c68d6113632810f","7316":"8c68d6113632810f","7729":"b548ecafda394ffa","8259":"8c68d6113632810f"}[chunkId] + ".css";
};